import { render } from "./Login.vue?vue&type=template&id=2ab8f2cb&scoped=true&bindings={}"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=2ab8f2cb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ab8f2cb"

export default script